import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <IndexSection />
        <FaqSection />
        <CarouselSection />
        <AboutSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
        <AppSection />
        <TopicsSection />
        <ContactSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}